function Button({
  type = 'button',
  variant = 'primary',
  className = '',
  children,
  icon: Icon,
  isLoading = false,
  disabled,
  ...rest
}) {
  const isPrimary = variant === 'primary';
  const base =
    'group relative inline-flex items-center justify-center gap-2 rounded-2xl px-5 py-3 text-sm font-medium tracking-tight transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-300/60 focus-visible:ring-offset-2 focus-visible:ring-offset-ink-950 disabled:cursor-not-allowed disabled:opacity-50';

  const variants = isPrimary
    ? 'text-white shadow-glow border border-white/10 bg-gradient-to-br from-violet-500/90 via-violet-500/80 to-cyan-400/80 hover:from-violet-400 hover:via-fuchsia-400 hover:to-cyan-300'
    : 'text-white/75 border border-white/10 bg-white/[0.04] hover:bg-white/[0.08] hover:text-white';

  return (
    <button
      type={type}
      disabled={disabled || isLoading}
      className={`${base} ${variants} ${className}`}
      {...rest}
    >
      <span className="absolute inset-0 overflow-hidden rounded-2xl opacity-0 transition-opacity duration-300 group-hover:opacity-100">
        <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/15 to-transparent bg-[length:200%_100%] animate-shimmer" />
      </span>
      <span className="relative flex items-center gap-2">
        {Icon && !isLoading && <Icon />}
        {isLoading && (
          <span
            aria-hidden="true"
            className="h-4 w-4 animate-spin rounded-full border-[1.5px] border-white/40 border-t-transparent"
          />
        )}
        {children}
      </span>
    </button>
  );
}

export default Button;